import React from "react";
import styled from 'styled-components';
import { Link } from 'gatsby';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    //min-height: 18vh;
    //margin-top: 0.5vh;
    width: 90%;

    color: var(--darkgreen);
    padding-bottom: 1vh;

    a{
        text-decoration: none;
        color: inherit;
    }

    .brand{        
        line-height: 90%;
        text-transform: uppercase;
        opacity: 0.8;

        margin: 0;
    }

    .product{
        font-family: IBM Plex Mono Bold;
        font-size: 20px;

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        text-overflow: ellipsis;
        overflow: hidden;

        @media(max-width: 1000px){
            font-size: 18px;
            height: 40px;
        }
    }

    .detail{
        line-height: 86.5%;
        margin: 1.5vh 0 0 0;
        opacity: 0.8;        
        padding: 0;
        font-size: max(0.8vw, 12px);
        min-height: 20px;
    }

    .price{
        margin-top: 1.5vh;
        display: flex;
        align-items: center;
        max-width: 65%;

        font-family: IBM Plex Mono Medium;
        font-weight: 300 !important;
        
        
        color: var(--darkgreen);

        .old{
            text-decoration: line-through;
            font-size: max(2vh, 16px);
            opacity: 0.6;
            margin-left: 1vw;
        }

        .special{
            font-family: IBM Plex Mono Bold;
            font-weight: 900;
            color: var(--darkgreen);
        }

        p{
            margin: 0;
            font-size: max(2.5vh, 18px);
        }
    }
`;

export default function Metadata({ product, amountIndex })
{
    var detail = "THC: ";

    if(product?.potencyThc?.formatted && product?.potencyThc?.formatted !== "")
    {
        detail += product?.potencyThc?.formatted.split(" ").join("") + "  |  CBD: ";
    }
    else
    {
        detail += "0%  |  CBD: ";
    }

    if(product?.potencyCbd?.formatted && product?.potencyCbd?.formatted !== "")
    {
        detail += product?.potencyCbd?.formatted.split(" ").join("");
    }
    else
    {
        detail += "0%";
    }

    return(
        <Wrapper type={product.strainType}>

            <Link to={`/menu/${product.id}`}>
                <p className="brand">{product.brand_name}</p>

                <p className="product">{product.name}</p>

                <p className="detail">
                    {detail}
                </p>
            </Link>

            <div className="price">
                {product.variants[amountIndex].specialPriceRec ? (
                    <>
                        <p className="special">${parseFloat(product.variants[amountIndex].specialPriceRec).toFixed(2)}</p>
                        <p className="old">${parseFloat(product.variants[amountIndex].priceRec).toFixed(2)}</p>
                    </>
                )
                : (
                    <p>${parseFloat(product.variants[amountIndex].priceRec).toFixed(2)}</p>
                )
                }                
            </div>
        </Wrapper>
    )
}